import dynamic from 'next/dynamic';

import { Dialog, Transition } from "@headlessui/react";
import React, { Fragment, useState } from "react";
const Icon = dynamic(() => import('@/components/ui/Icon'), { ssr: false });

const MessageModal = ({
  status,
  activeModal,
  onClose,
  noFade,
  disableBackdrop,
  className = "max-w-xl",
  children,
  footerContent,
  centered,
  scrollContent,
  themeClass = (status === true ? "bg-metaxseed-blue" : "bg-metaxseed-orange") + " ",
  title = "Basic Modal",
  uncontrol,
  label = "Basic Modal",
  labelClass,
  fireworks = false,
  ref,
}) => {
  const [showModal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(!showModal);
  };
  const returnNull = () => {
    return null;
  };

  return (
    <>
      {uncontrol ? (
        <>
          <button
            type="button"
            onClick={openModal}
            className={`btn ${labelClass}`}
          >
            {label}
          </button>
          <Transition appear show={showModal} as={Fragment}>
            <Dialog
              as="div"
              className="relative z-[99999]"
              onClose={!disableBackdrop ? closeModal : returnNull}
            >
              {!disableBackdrop && (
                <Transition.Child
                  as={Fragment}
                  enter={noFade ? "" : "duration-300 ease-out"}
                  enterFrom={noFade ? "" : "opacity-0"}
                  enterTo={noFade ? "" : "opacity-100"}
                  leave={noFade ? "" : "duration-200 ease-in"}
                  leaveFrom={noFade ? "" : "opacity-100"}
                  leaveTo={noFade ? "" : "opacity-0"}
                >
                  <div className="fixed inset-0 bg-metaxseed-black/50 backdrop-filter backdrop-blur-sm" />
                </Transition.Child>
              )}

<div className={"fixed inset-0" + (!fireworks ? ' overflow-y-auto' : '')}>
                {fireworks && (
            <div className="fireworksWrapper">
            <div className="before"></div>
            <div className="after"></div>
        </div>
                )}
                <div
                  className={`flex min-h-full justify-center text-center p-6 ${
                    centered ? "items-center" : "items-start "
                  }`}
                >
                  <Transition.Child
                    as={Fragment}
                    enter={noFade ? "" : "duration-300  ease-out"}
                    enterFrom={noFade ? "" : "opacity-0 scale-95"}
                    enterTo={noFade ? "" : "opacity-100 scale-100"}
                    leave={noFade ? "" : "duration-200 ease-in"}
                    leaveFrom={noFade ? "" : "opacity-100 scale-100"}
                    leaveTo={noFade ? "" : "opacity-0 scale-95"}
                  >
                    <Dialog.Panel
                      className={`w-full transform overflow-hidden rounded-md bg-metaxseed-dark-gray text-left align-middle shadow-xl transition-all ${className}`}
                    >
                      <div
                        className={`relative overflow-hidden  outline-none py-4 px-8 text-white flex justify-between  ${themeClass}`}
                      >
                        <h2 className="capitalize leading-6 tracking-wider gothamMedium font-normal text-base text-white">
                          {title}
                        </h2>
                        <button onClick={closeModal} className="text-[22px] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none !shadow-none">
                          <Icon icon="heroicons-outline:x" />
                        </button>
                      </div>
                      <div
                        className={`px-8 py-4 bg-metaxseed-dark-gray text-white gothamBook ${
                          scrollContent ? "overflow-y-auto max-h-[400px]" : ""
                        }`}
                      >
                        {children}
                      </div>
                      {footerContent && (
                        <div className="px-8 py-4 bg-metaxseed-dark-gray flex justify-end space-x-3">
                          {footerContent}
                        </div>
                      )}
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </>
      ) : (
        <Transition appear show={activeModal} as={Fragment}>
          <Dialog as="div" className="relative z-[99999]" onClose={onClose}>

          {!disableBackdrop && (
                <Transition.Child
                  as={Fragment}
                  enter={noFade ? "" : "duration-300 ease-out"}
                  enterFrom={noFade ? "" : "opacity-0"}
                  enterTo={noFade ? "" : "opacity-100"}
                  leave={noFade ? "" : "duration-200 ease-in"}
                  leaveFrom={noFade ? "" : "opacity-100"}
                  leaveTo={noFade ? "" : "opacity-0"}
                >
                  <div className="fixed inset-0 bg-metaxseed-black/50 backdrop-filter backdrop-blur-sm" />
                </Transition.Child>
              )}

<div className={"fixed inset-0" + (!fireworks ? ' overflow-y-auto' : '')}>
                {fireworks && (
            <div className="fireworksWrapper">
            <div className="before"></div>
            <div className="after"></div>
        </div>
                )}
              <div
                className={`flex min-h-full justify-center text-center p-6 ${
                  centered ? "items-center" : "items-start "
                }`}
              >
                <Transition.Child
                  as={Fragment}
                  enter={noFade ? "" : "duration-300  ease-out"}
                  enterFrom={noFade ? "" : "opacity-0 scale-95"}
                  enterTo={noFade ? "" : "opacity-100 scale-100"}
                  leave={noFade ? "" : "duration-200 ease-in"}
                  leaveFrom={noFade ? "" : "opacity-100 scale-100"}
                  leaveTo={noFade ? "" : "opacity-0 scale-95"}
                >
                  <Dialog.Panel
                    className={`w-full transform overflow-hidden rounded-md 
                    bg-metaxseed-dark-gray text-left align-middle shadow-xl transition-all ${className}`}
                  >
                    <div
                        className={`relative overflow-hidden  outline-none py-4 px-8 text-white flex justify-between  ${themeClass}`}
                    >
                      <h2 className="capitalize leading-6 tracking-wider gothamMedium font-normal text-base text-white">
                        {title}
                      </h2>
                      <button onClick={onClose} className="text-[22px] !ring-0 !ring-transparent !ring-offset-0 outline-none hover:outline-none !shadow-none">
                        <Icon icon="heroicons-outline:x" />
                      </button>
                    </div>
                    <div
                      className={`bg-metaxseed-dark-gray text-white px-8 py-4 gothamBook ${
                        scrollContent ? "overflow-y-auto max-h-[400px]" : ""
                      }`}
                    >
                      {children}
                    </div>
                    {footerContent && (
                      <div className="bg-metaxseed-dark-gray px-8 py-4 flex justify-end space-x-3">
                        {footerContent}
                      </div>
                    )}
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition>
      )}
    </>
  );
};

export default MessageModal;
